var chips = document.querySelectorAll<HTMLElement>(".brands-filters button");
var cards = document.querySelectorAll<HTMLElement>(".brand-card");
chips.forEach(function (c) {
  c.addEventListener("click", function () {
    chips.forEach(function (x) {
      x.classList.remove("is-active");
    });
    c.classList.add("is-active");
    var f = c.dataset.f ?? "";
    cards.forEach(function (card) {
      var cats = (card.dataset.cat || "").split(/\s+/);
      card.classList.toggle(
        "is-hidden",
        f !== "all" && cats.indexOf(f) === -1,
      );
    });
  });
});
var yr = document.getElementById("yr");
if (yr) yr.textContent = String(new Date().getFullYear());